import { render, staticRenderFns } from "./MdInfo.vue?vue&type=template&id=d95c27f0"
import script from "./MdInfo.vue?vue&type=script&lang=ts"
export * from "./MdInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports